// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavMenu_wrapper__T6SAM","item":"NavMenu_item__3tO83","activeItem":"NavMenu_activeItem__2Ak7p","menuItem":"NavMenu_menuItem__38Gf8","navLink":"NavMenu_navLink__2DNCv"};